import React from "react";

const strengths = [
  "Established in 2010 with a steady industrial client base",
  "ISO 9001:2015 oriented quality and process control approach",
  "Custom packaging development for different product categories",
  "Reliable dispatch planning backed by in-house transport support",
  "Experienced team for production, inspection, and delivery coordination"
];

const industries = [
  "Automobile components",
  "Engineering and machine parts",
  "Electronics and control panels",
  "Computers and IT equipment",
  "Laboratory equipment",
  "Food and pharmaceutical support packaging"
];

function About() {
  return (
    <div className="page-shell">
      <section className="page-hero page-hero-light">
        <div className="container">
          <p className="eyebrow">About Us</p>
          <h1>Built on quality, consistency, and long-term customer trust</h1>
          <p>
            SAI VENKATESHWARA PACKAGES has been serving industrial clients since 2010 with dependable packaging
            solutions designed for durability, safety, and operational efficiency.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container split-layout">
          <div className="content-card">
            <p className="eyebrow">Company Profile</p>
            <h2>Professional packaging manufacturing from Hosur</h2>
            <p>
              We manufacture corrugated boxes, angle boards, PET straps, wrappers, and air bubble rolls using
              quality-approved materials and process-focused production methods.
            </p>
            <p>
              Our goal is simple: deliver packaging that performs reliably, protects products effectively, and supports
              the business continuity of our clients.
            </p>
          </div>
          <div className="stats-stack">
            <div className="stat-panel">
              <strong>2010</strong>
              <span>Established with a focus on industrial packaging</span>
            </div>
            <div className="stat-panel">
              <strong>ISO 9001:2015</strong>
              <span>Quality-oriented systems and disciplined workflows</span>
            </div>
            <div className="stat-panel">
              <strong>2 Plants</strong>
              <span>Production capability designed for responsive supply</span>
            </div>
          </div>
        </div>
      </section>

      <section className="section section-muted">
        <div className="container grid cards-2">
          <article className="info-card large-card">
            <p className="eyebrow">Mission</p>
            <h3>Deliver protective packaging that creates operational confidence</h3>
            <p>
              We aim to provide dependable, cost-effective, and custom-built packaging solutions that reduce damage,
              improve handling, and strengthen client satisfaction.
            </p>
          </article>
          <article className="info-card large-card">
            <p className="eyebrow">Vision</p>
            <h3>Be the preferred packaging partner for growth-focused industries</h3>
            <p>
              We continue to invest in better processes, stronger materials, and more responsive service to support
              long-term industrial relationships.
            </p>
          </article>
        </div>
      </section>

      <section className="section">
        <div className="container split-layout">
          <div>
            <p className="eyebrow">Our Strengths</p>
            <h2>Why businesses stay with us</h2>
            <div className="check-list">
              {strengths.map((item) => (
                <div key={item} className="check-item">
                  <span></span>
                  <p>{item}</p>
                </div>
              ))}
            </div>
          </div>
          <div>
            <p className="eyebrow">Industries Served</p>
            <h2>Packaging support across multiple sectors</h2>
            <div className="industry-grid">
              {industries.map((item) => (
                <div key={item} className="industry-card">
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
